import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import AchievementComponent from "utils/AchievementComponent";
import SocialComponent from "utils/SocialComponent";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const levels = [
  { label: "داخلی", value: "domestic" },
  { label: "بین المللی", value: "international" },
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, [
              "coach",
              "players",
              "staff",
              "viceCaptain",
              "captain",
            ]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام کوتاه"
                    label="نام کوتاه :"
                    name="translations.fa.shortName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام کوتاه(en)"
                    label="نام کوتاه (en):"
                    name="translations.en.shortName"
                    component={TextField}
                  />
                  <Field
                    placeholder="کشور"
                    label="کشور :"
                    name="translations.fa.country"
                    component={TextField}
                  />
                  <Field
                    placeholder="کشور(en)"
                    label="کشور(en) :"
                    name="translations.en.country"
                    component={TextField}
                  />
                  <Field
                    placeholder="شهر"
                    label="شهر :"
                    name="translations.fa.city"
                    component={TextField}
                  />
                  <Field
                    placeholder="شهر(en)"
                    label="شهر(en) :"
                    name="translations.en.city"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام استادیوم خانگی تیم"
                    label="نام استادیوم خانگی تیم :"
                    name="translations.fa.homeStadium"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام استادیوم خانگی تیم(en)"
                    label="نام استادیوم خانگی تیم(en) :"
                    name="translations.en.homeStadium"
                    component={TextField}
                  />
                  <Field
                    placeholder="رنگ اصلی تیم"
                    label="رنگ اصلی تیم :"
                    name="translations.fa.primaryColor"
                    component={TextField}
                  />
                  <Field
                    placeholder="رنگ اصلی تیم(en)"
                    label="رنگ اصلی تیم(en) :"
                    name="translations.en.primaryColor"
                    component={TextField}
                  />
                  <Field
                    placeholder=" رنگ دوم تیم"
                    label=" رنگ دوم تیم :"
                    name="translations.fa.secondaryColor"
                    component={TextField}
                  />
                  <Field
                    placeholder=" رنگ دوم تیم(en)"
                    label=" رنگ دوم تیم(en) :"
                    name="translations.en.secondaryColor"
                    component={TextField}
                  />

                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="intro-y">
                    <Field
                      label="کاپیتان :"
                      name="captain"
                      component={SearchSelect}
                      searchFields="translations.name,translations.lastName"
                      collectionName="player"
                      showFields="translations.name,translations.lastName"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="کاپیتان دوم :"
                      name="viceCaptain"
                      component={SearchSelect}
                      searchFields="translations.name,translations.lastName"
                      collectionName="player"
                      showFields="translations.name,translations.lastName"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <Field
                    placeholder="وبسایت"
                    label="وبسایت:"
                    name="officialWebsite"
                    component={TextField}
                  />
                  <Field
                    label="وضعیت :"
                    name="isActive"
                    component={Select}
                    options={[
                      { value: true, label: "فعال" },
                      { value: false, label: "غیر فعال" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <span> ارزش بازار تیم :</span>
                    <Field
                      label="  ارزش بازار تیم: "
                      name="marketValue"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> بودجه :</span>
                    <Field
                      label="بودجه : "
                      name="budget"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> تعداد کل مسابقات:</span>
                    <Field
                      label=" تعداد کل مسابقات: "
                      name="matchesPlayed"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> مجموع گل‌های خورده شده:</span>
                    <Field
                      label=" مجموع گل‌های خورده شده: "
                      name="totalGoalsConceded"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> مجموع گل‌های زده شده:</span>
                    <Field
                      label=" مجموع گل‌های زده شده: "
                      name="totalGoalsScored"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> تعداد مساوی‌ها:</span>
                    <Field
                      label="  تعداد مساوی‌ها: "
                      name="totalDraws"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> تعداد باخت‌ها:</span>
                    <Field
                      label=" تعداد باخت‌ها: "
                      name="totalLosses"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> تعداد بردها:</span>
                    <Field
                      label=" تعداد بردها: "
                      name="totalWins"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="سطح تیم :"
                      name="level"
                      component={Select}
                      options={levels}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label=" کادر:"
                    name="staff"
                    component={MultySearchSelect}
                    searchFields="translations.name,translations.lastName"
                    collectionName="staff"
                    showFields="translations.name,translations.lastName"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label=" بازیکنان:"
                    name="players"
                    component={MultySearchSelect}
                    searchFields="translations.name,translations.lastName"
                    collectionName="player"
                    showFields="translations.name,translations.lastName"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <Field
                      label=" مربی :"
                      name="coach"
                      component={SearchSelect}
                      searchFields="translations.name,translations.lastName"
                      collectionName="coach"
                      showFields="translations.name,translations.lastName"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="لوگو"
                      name="logo"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <AchievementComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Team"
                />
                <SocialComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Team"
                />
                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Team"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
